import {
  APP_ROUTE_PATIENT_APPOINTMENTS,
  APP_ROUTE_PATIENT_CHARTS,
  APP_ROUTE_PATIENT_MEDICATIONS
} from './patientRoutes'
import { APP_ROUTES_INDEX } from './routes'

export type PatientSidebarIconKey =
  | 'appointments'
  | 'charts'
  | 'dashboard'
  | 'logout'
  | 'medications'
  | 'messages'
  | 'support'

export type PatientSidebarItem = {
  icon: PatientSidebarIconKey
  id: string
  label: string
  path: string
  badge?: number
}

export const PATIENT_SIDEBAR_ITEMS: PatientSidebarItem[] = [
  { icon: 'dashboard', id: 'dashboard', label: 'Dashboard', path: APP_ROUTES_INDEX },
  { icon: 'appointments', id: 'appointments', label: 'Appointments', path: APP_ROUTE_PATIENT_APPOINTMENTS },
  // { badge: 8, icon: 'messages', id: 'messages', label: 'Messages', path: APP_ROUTE_PATIENT_MESSAGES },
  { icon: 'charts', id: 'my-charts', label: 'My Charts', path: APP_ROUTE_PATIENT_CHARTS },
  // { icon: 'charts', id: 'my-charts-2', label: 'My Charts', path: '/patient/charts-archive' },
  { icon: 'medications', id: 'medications', label: 'Medications', path: APP_ROUTE_PATIENT_MEDICATIONS }
]

export const PATIENT_SIDEBAR_FOOTER_ITEMS: PatientSidebarItem[] = [
  { icon: 'support', id: 'support', label: 'Support', path: '/patient/support' },
  { icon: 'logout', id: 'logout', label: 'Log out', path: '/login' }
]
